export function isEnumValue<T extends string | number>(obj: Record<string, T>, value: string | number): value is T {
  const enumValues = Object.values(obj) as Array<string | number>;

  return enumValues.includes(value)
}
